import { Outlet } from 'react-router-dom';
import { css, keyframes } from '@emotion/react';
import { createStackBackgroundUri } from 'client/components/Icons/StackBackground';
import { Color } from 'client/Theme';

export const AnonymousTrialPageLayout = () => (
  <div css={backgroundStyle}>
    <Outlet />
  </div>
);

const background = createStackBackgroundUri({ size: 16, primary: 'rgba(255, 255, 255, 0.05)', secondary: 'rgba(255, 255, 255, 0.05)' });
const backgroundColor = createStackBackgroundUri({ size: 16, primary: Color.primary[100], secondary: Color.secondary[100], chance: 0.15 });

const backgroundAnimation = keyframes`
  0% {
    --size: 400px;
  }
  100% {
    --size: 600px;
  }
`;

const backgroundStyle = css`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: black;

  &::after {
    position: absolute;
    content: '';
    display: block;
    width: 120%;
    height: 180%;
    background-image: ${background};
    background-size: 896px;
    transform: rotate(8deg);
  }

  &::before {
    @property --size {
      syntax: '<length>';
      inherits: false;
      initial-value: 400px;
    }

    position: absolute;
    content: '';
    display: block;
    width: 120%;
    height: 180%;
    background-image: ${backgroundColor};
    background-size: 896px;
    transform: rotate(8deg);

    mask-image: radial-gradient(circle at center, white 100px, transparent var(--size));

    animation: ${backgroundAnimation} 10s infinite alternate ease-in-out;
  }
`;
